const perf = function () {
    if (!window.performance || !window.performance.getEntries) {
        return;
    }
    // 平均值
    let getAverageValue = (arr) => {
        let sum = 0;
        for (let i = 0; i < arr.length; i++) {
            sum += Number(arr[i]);
        }
        return Math.floor(sum / arr.length);
    };
    // 获取域名
    let getHost = (url) => {
        if (url.indexOf('//') < 0) {
            return url;
        }
        let host_path = url.split('//')[1];

        return host_path.split('/')[0];
    };
    // 获得最大值
    let getMax = (arr) => {
        let max = arr[0];
        for (let i = 1; i < arr.length; i++) {
            let element = arr[i];
            if (element > max) {
                max = element;
            }
        }
        return parseInt(max, 10);
    };
    // 获得最小值
    let getMin = (arr) => {
        let min = arr[0];
        for (let i = 1; i < arr.length; i++) {
            let element = arr[i];
            if (element < min) {
                min = element;
            }
        }
        return parseInt(min, 10);
    };

    let handleNavigation = (element) => {
        let paint = performance.getEntriesByType('paint');
        let paintStartTime = 0;
        if (paint && paint.length) {
            paintStartTime = paint[0].startTime || 0;
        }

        let times = {
            DNS: element.domainLookupEnd - element.domainLookupStart,
            CONNECT: element.connectEnd - element.connectStart,
            REQUEST: element.responseEnd - element.requestStart,
            PAINT: paintStartTime - element.responseEnd
        };

        for (var i in times) {
            if (parseInt(times[i], 10) > 0) {
                ga('send', 'timing', 'NAVIGATION', i, parseInt(times[i], 10), location.hostname);
            }
        }
    };
    let getEntries = window.performance.getEntries();

    let imgObj = {};

    let ajaxObj = {};

    let jsRequeststartArr = [];
    let jsResponseEndArr = [];
    let jsHostname;
    let cssRequeststartArr = [];
    let cssResponseEndArr = [];
    let cssHostname;

    for (let i = 0; i < getEntries.length; i++) {
        let element = getEntries[i];
        let hostname = getHost(element.name);

        if (hostname.indexOf('allfootballapp') < 0 && hostname.indexOf('dongqiudi') < 0) {
            continue;
        }

        if (element.initiatorType === 'script') {
            jsRequeststartArr.push(element.requestStart || element.startTime);
            jsResponseEndArr.push(element.responseEnd);
            jsHostname = element.name;
        } else if (element.initiatorType === 'link') {
            cssRequeststartArr.push(element.requestStart || element.startTime);
            cssResponseEndArr.push(element.responseEnd);
            cssHostname = element.name;
        } else if (element.initiatorType === 'xmlhttprequest') {
            if (!ajaxObj[getHost(element.name)]) {
                ajaxObj[getHost(element.name)] = element.duration.toString();
            } else {
                ajaxObj[getHost(element.name)] = ajaxObj[getHost(element.name)] + ',' + element.duration;
            }
        } else if (element.initiatorType === 'img') {
            if (!imgObj[getHost(element.name)]) {
                imgObj[getHost(element.name)] = element.duration.toString();
            } else {
                imgObj[getHost(element.name)] = imgObj[getHost(element.name)] + ',' + element.duration;
            }
        }
        if (element.entryType === 'navigation') {
            handleNavigation(element);
        }
    }
    // 发图片
    for (let key in imgObj) {
        let imgArr = imgObj[key].split(',');
        imgObj[key] = imgArr;
        ga('send', 'timing', 'IMG', 'duration', getAverageValue(imgArr), key);
    }
    // ajax
    for (let key in ajaxObj) {
        let ajaxArr = ajaxObj[key].split(',');
        ajaxObj[key] = ajaxArr;
        console.log(ajaxArr);
        ga('send', 'timing', 'AJAX', 'duration', getAverageValue(ajaxArr), key);
        console.log('平均值', getAverageValue(ajaxArr));
    }
    // 发js
    ga('send', 'timing', 'JS', 'duration', getMax(jsResponseEndArr) - getMin(jsRequeststartArr), jsHostname);
    // 发css
    ga('send', 'timing', 'CSS', 'duration', getMax(cssResponseEndArr) - getMin(cssRequeststartArr), cssHostname);
};

if (typeof window !== 'undefined' && window.addEventListener && Math.random() < 0.01) {
    window.addEventListener('load', () => {
        setTimeout(perf, 2000); // onload后2s统计
    });
}



// WEBPACK FOOTER //
// ./src/util/performance.js